import React, { useEffect, useState } from 'react';
import { Grid, Typography, Box, Container, ToggleButtonGroup, ToggleButton } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const HowItWorks = ({ title, isTenants = false, isOwners = false }) => {
  const { t } = useTranslation();

  const [userType, setUserType] = useState('tenant');

  useEffect(() => {
    if (isTenants) {
      setUserType('tenant');
    }
    if (isOwners) {
      setUserType('owner');
    }
  }, [isTenants, isOwners]);

  const handleChange = (event, newUserType) => {
    if (newUserType !== null) {
      setUserType(newUserType);
    }
  };
  const tenantSteps = [
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="52"
          viewBox="0 0 53 52"
          fill="none">
          <path
            opacity="0.2"
            d="M47.7225 43.4139C47.8047 43.6939 47.81 43.9909 47.7378 44.2737C47.6657 44.5564 47.5187 44.8145 47.3123 45.0209C47.106 45.2272 46.8479 45.3742 46.5651 45.4463C46.2824 45.5185 45.9854 45.5132 45.7054 45.431L40.0728 43.7735C38.2121 44.7685 36.1583 45.3495 34.0521 45.4766C31.9459 45.6036 29.8371 45.2737 27.8704 44.5095C25.9036 43.7453 24.1253 42.5648 22.6575 41.049C21.1896 39.5333 20.0669 37.718 19.3662 35.7277C19.6323 35.7419 19.8984 35.75 20.1665 35.75C22.5041 35.7502 24.8078 35.19 26.8843 34.1165C28.9608 33.0429 30.7497 31.4872 32.1011 29.5798C33.4525 27.6724 34.327 25.4688 34.6512 23.1538C34.9755 20.8387 34.7401 18.4797 33.9648 16.2744C36.4215 16.4078 38.8049 17.1589 40.8943 18.458C42.9837 19.7572 44.7115 21.5624 45.9179 23.7067C47.1243 25.851 47.7703 28.2649 47.796 30.7251C47.8217 33.1854 47.2263 35.6123 46.065 37.7813L47.7225 43.4139Z"
            fill="#3E63DD"
          />
          <path
            d="M47.8057 37.9356C48.9285 35.6067 49.4794 33.0436 49.4127 30.459C49.346 27.8745 48.6636 25.3431 47.4221 23.0753C46.1806 20.8075 44.4159 18.8686 42.2746 17.4197C40.1333 15.9709 37.6772 15.0538 35.1103 14.7448C34.2562 12.759 33.0145 10.9636 31.4579 9.46362C29.9012 7.96368 28.0609 6.78941 26.0448 6.00956C24.0287 5.22971 21.8772 4.85996 19.7164 4.92197C17.5556 4.98398 15.4288 5.4765 13.4607 6.37068C11.4926 7.26486 9.72273 8.54274 8.25466 10.1295C6.78659 11.7162 5.64986 13.5799 4.91105 15.6115C4.17223 17.643 3.84618 19.8015 3.95198 21.9606C4.05778 24.1197 4.59332 26.236 5.52722 28.1856L4.0505 33.2048C3.88539 33.7651 3.87435 34.3596 4.01854 34.9257C4.16273 35.4917 4.45682 36.0085 4.86987 36.4215C5.28292 36.8346 5.79967 37.1287 6.36573 37.2729C6.9318 37.4171 7.52627 37.406 8.08659 37.2409L13.1058 35.7642C14.7175 36.5385 16.4454 37.0429 18.2205 37.2572C19.0829 39.2779 20.3462 41.1027 21.9338 42.6213C23.5215 44.14 25.4007 45.3209 27.4577 46.0927C29.5147 46.8645 31.7068 47.2112 33.9016 47.1117C36.0964 47.0123 38.2483 46.4688 40.2271 45.5142L45.2463 46.9909C45.8064 47.1558 46.4006 47.1668 46.9664 47.0227C47.5322 46.8786 48.0488 46.5847 48.4618 46.1719C48.8747 45.7592 49.1689 45.2428 49.3133 44.677C49.4577 44.1113 49.447 43.5171 49.2824 42.9569L47.8057 37.9356ZM13.2602 32.3984C13.1049 32.3988 12.9504 32.4207 12.8011 32.4634L7.16643 34.125L8.82596 28.4862C8.94399 28.0788 8.89807 27.6415 8.698 27.2675C7.228 24.5183 6.79487 21.3325 7.47755 18.2907C8.16023 15.2489 9.91327 12.5537 12.4171 10.6964C14.9209 8.83916 18.0088 7.9435 21.1178 8.17271C24.2269 8.40193 27.15 9.74075 29.3544 11.9451C31.5588 14.1495 32.8976 17.0727 33.1268 20.1817C33.356 23.2907 32.4604 26.3786 30.6031 28.8824C28.7458 31.3863 26.0506 33.1393 23.0088 33.822C19.967 34.5047 16.7812 34.0715 14.0321 32.6015C13.7957 32.4707 13.5304 32.4009 13.2602 32.3984ZM44.4988 38.2342L46.1664 43.875L40.5277 42.2155C40.1203 42.0974 39.6829 42.1433 39.3089 42.3434C36.3166 43.9413 32.8184 44.3071 29.5602 43.3631C26.3019 42.419 23.5413 40.2397 21.8666 37.2897C24.0916 37.0574 26.2446 36.3679 28.1905 35.2643C30.1364 34.1608 31.8333 32.667 33.1746 30.8766C34.516 29.0863 35.4729 27.0381 35.9853 24.8605C36.4977 22.6829 36.5546 20.4229 36.1524 18.2223C38.091 18.6793 39.8987 19.5756 41.4359 20.842C42.9731 22.1085 44.1988 23.7112 45.0183 25.5265C45.8379 27.3419 46.2293 29.3212 46.1625 31.3118C46.0956 33.3024 45.5723 35.2511 44.6328 37.0073C44.4306 37.3836 44.3846 37.8243 44.5049 38.2342H44.4988Z"
            fill="#3E63DD"
          />
        </svg>
      ),
      number: '1',
      title: t('Start a Smart Chat'),
      color: '#AEC2FF',
      description: t(
        'Begin with a quick, intuitive conversation. No filters, no forms—just tell the assistant what matters to you.'
      )
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="62"
          height="16"
          viewBox="0 0 62 16"
          fill="none">
          <path
            d="M61.0404 8.70711C61.4309 8.31658 61.4309 7.68342 61.0404 7.29289L54.6764 0.928932C54.2859 0.538408 53.6527 0.538408 53.2622 0.928932C52.8717 1.31946 52.8717 1.95262 53.2622 2.34315L58.919 8L53.2622 13.6569C52.8717 14.0474 52.8717 14.6805 53.2622 15.0711C53.6527 15.4616 54.2859 15.4616 54.6764 15.0711L61.0404 8.70711ZM0.333252 9H60.3333V7H0.333252V9Z"
            fill="#8DA4EF"
          />
        </svg>
      )
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="52"
          height="52"
          viewBox="0 0 52 52"
          fill="none">
          <path opacity="0.2" d="M35.75 16.25V35.75H16.25V16.25H35.75Z" fill="#65BA74" />
          <path
            d="M45.5 8.125V16.25C45.5 16.681 45.3288 17.0943 45.024 17.399C44.7193 17.7038 44.306 17.875 43.875 17.875C43.444 17.875 43.0307 17.7038 42.726 17.399C42.4212 17.0943 42.25 16.681 42.25 16.25V9.75H35.75C35.319 9.75 34.9057 9.57879 34.601 9.27405C34.2962 8.9693 34.125 8.55598 34.125 8.125C34.125 7.69402 34.2962 7.2807 34.601 6.97595C34.9057 6.67121 35.319 6.5 35.75 6.5H43.875C44.306 6.5 44.7193 6.67121 45.024 6.97595C45.3288 7.2807 45.5 7.69402 45.5 8.125ZM16.25 42.25H9.75V35.75C9.75 35.319 9.57879 34.9057 9.27405 34.601C8.9693 34.2962 8.55598 34.125 8.125 34.125C7.69402 34.125 7.2807 34.2962 6.97595 34.601C6.67121 34.9057 6.5 35.319 6.5 35.75V43.875C6.5 44.306 6.67121 44.7193 6.97595 45.024C7.2807 45.3288 7.69402 45.5 8.125 45.5H16.25C16.681 45.5 17.0943 45.3288 17.399 45.024C17.7038 44.7193 17.875 44.306 17.875 43.875C17.875 43.444 17.7038 43.0307 17.399 42.726C17.0943 42.4212 16.681 42.25 16.25 42.25ZM43.875 34.125C43.444 34.125 43.0307 34.2962 42.726 34.601C42.4212 34.9057 42.25 35.319 42.25 35.75V42.25H35.75C35.319 42.25 34.9057 42.4212 34.601 42.726C34.2962 43.0307 34.125 43.444 34.125 43.875C34.125 44.306 34.2962 44.7193 34.601 45.024C34.9057 45.3288 35.319 45.5 35.75 45.5H43.875C44.306 45.5 44.7193 45.3288 45.024 45.024C45.3288 44.7193 45.5 44.306 45.5 43.875V35.75C45.5 35.319 45.3288 34.9057 45.024 34.601C44.7193 34.2962 44.306 34.125 43.875 34.125ZM8.125 17.875C8.55598 17.875 8.9693 17.7038 9.27405 17.399C9.57879 17.0943 9.75 16.681 9.75 16.25V9.75H16.25C16.681 9.75 17.0943 9.57879 17.399 9.27405C17.7038 8.9693 17.875 8.55598 17.875 8.125C17.875 7.69402 17.7038 7.2807 17.399 6.97595C17.0943 6.67121 16.681 6.5 16.25 6.5H8.125C7.69402 6.5 7.2807 6.67121 6.97595 6.97595C6.67121 7.2807 6.5 7.69402 6.5 8.125V16.25C6.5 16.681 6.67121 17.0943 6.97595 17.399C7.2807 17.7038 7.69402 17.875 8.125 17.875ZM16.25 14.625H35.75C36.181 14.625 36.5943 14.7962 36.899 15.101C37.2038 15.4057 37.375 15.819 37.375 16.25V35.75C37.375 36.181 37.2038 36.5943 36.899 36.899C36.5943 37.2038 36.181 37.375 35.75 37.375H16.25C15.819 37.375 15.4057 37.2038 15.101 36.899C14.7962 36.5943 14.625 36.181 14.625 35.75V16.25C14.625 15.819 14.7962 15.4057 15.101 15.101C15.4057 14.7962 15.819 14.625 16.25 14.625ZM17.875 34.125H34.125V17.875H17.875V34.125Z"
            fill="#65BA74"
          />
        </svg>
      ),
      number: '2',
      title: t('Share What You Need'),
      color: '#65BA74',
      description: t(
        'Budget, location, commute preferences, family needs, lifestyle choices—HomeAI listens and asks the right questions.'
      )
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="62"
          height="16"
          viewBox="0 0 62 16"
          fill="none">
          <path
            d="M61.3736 8.70711C61.7641 8.31658 61.7641 7.68342 61.3736 7.29289L55.0097 0.928932C54.6191 0.538408 53.986 0.538408 53.5954 0.928932C53.2049 1.31946 53.2049 1.95262 53.5954 2.34315L59.2523 8L53.5954 13.6569C53.2049 14.0474 53.2049 14.6805 53.5954 15.0711C53.986 15.4616 54.6191 15.4616 55.0097 15.0711L61.3736 8.70711ZM0.666504 9H60.6665V7H0.666504V9Z"
            fill="#65BA74"
          />
        </svg>
      ),
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="52"
          viewBox="0 0 53 52"
          fill="none">
          <path opacity="0.2" d="M42.5833 8.125V42.25H31.2083V8.125H42.5833Z" fill="#AA99EC" />
          <path
            d="M45.8333 40.625H44.2083V8.125C44.2083 7.69402 44.037 7.2807 43.7323 6.97595C43.4276 6.67121 43.0142 6.5 42.5833 6.5H31.2083C30.7773 6.5 30.3639 6.67121 30.0592 6.97595C29.7545 7.2807 29.5833 7.69402 29.5833 8.125V16.25H19.8333C19.4023 16.25 18.989 16.4212 18.6842 16.726C18.3795 17.0307 18.2083 17.444 18.2083 17.875V26H10.0833C9.65228 26 9.23895 26.1712 8.9342 26.476C8.62946 26.7807 8.45825 27.194 8.45825 27.625V40.625H6.83325C6.40228 40.625 5.98895 40.7962 5.6842 41.101C5.37946 41.4057 5.20825 41.819 5.20825 42.25C5.20825 42.681 5.37946 43.0943 5.6842 43.399C5.98895 43.7038 6.40228 43.875 6.83325 43.875H45.8333C46.2642 43.875 46.6776 43.7038 46.9823 43.399C47.287 43.0943 47.4583 42.681 47.4583 42.25C47.4583 41.819 47.287 41.4057 46.9823 41.101C46.6776 40.7962 46.2642 40.625 45.8333 40.625ZM32.8333 9.75H40.9583V40.625H32.8333V9.75ZM21.4583 19.5H29.5833V40.625H21.4583V19.5ZM11.7083 29.25H18.2083V40.625H11.7083V29.25Z"
            fill="#AA99EC"
          />
        </svg>
      ),
      number: '3',
      title: t('Let the AI Go to Work'),
      color: '#AA99EC',
      description: t(
        t(
          'Our assistant instantly analyzes thousands of listings using over 60 data points, from tax zones to balcony views.'
        )
      )
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="52"
          viewBox="0 0 53 52"
          fill="none">
          <path
            opacity="0.2"
            d="M39.6665 17.875V40.625C39.6665 41.056 39.4953 41.4693 39.1906 41.774C38.8858 42.0788 38.4725 42.25 38.0415 42.25H8.7915C8.36053 42.25 7.9472 42.0788 7.64246 41.774C7.33771 41.4693 7.1665 41.056 7.1665 40.625V17.875C7.1665 17.444 7.33771 17.0307 7.64246 16.726C7.9472 16.4212 8.36053 16.25 8.7915 16.25H38.0415C38.4725 16.25 38.8858 16.4212 39.1906 16.726C39.4953 17.0307 39.6665 17.444 39.6665 17.875Z"
            fill="#65BA74"
          />
          <path
            d="M38.0415 14.625H8.7915C7.92955 14.625 7.1029 14.9674 6.49341 15.5769C5.88391 16.1864 5.5415 17.013 5.5415 17.875V40.625C5.5415 41.487 5.88391 42.3136 6.49341 42.9231C7.1029 43.5326 7.92955 43.875 8.7915 43.875H38.0415C38.9035 43.875 39.7301 43.5326 40.3396 42.9231C40.9491 42.3136 41.2915 41.487 41.2915 40.625V17.875C41.2915 17.013 40.9491 16.1864 40.3396 15.5769C39.7301 14.9674 38.9035 14.625 38.0415 14.625ZM38.0415 40.625H8.7915V17.875H38.0415V40.625ZM47.7915 11.375V35.75C47.7915 36.181 47.6203 36.5943 47.3156 36.899C47.0108 37.2038 46.5975 37.375 46.1665 37.375C45.7355 37.375 45.3222 37.2038 45.0175 36.899C44.7127 36.5943 44.5415 36.181 44.5415 35.75V11.375H13.6665C13.2355 11.375 12.8222 11.2038 12.5175 10.899C12.2127 10.5943 12.0415 10.181 12.0415 9.75C12.0415 9.31902 12.2127 8.9057 12.5175 8.60095C12.8222 8.29621 13.2355 8.125 13.6665 8.125H44.5415C45.4035 8.125 46.2301 8.46741 46.8396 9.0769C47.4491 9.6864 47.7915 10.513 47.7915 11.375Z"
            fill="#65BA74"
          />
        </svg>
      ),
      number: '4',
      title: t('Get Tailored Matches'),
      color: '#E0E7FD',
      description: t(
        'You’ll receive a curated shortlist of properties—with clear explanations of why each one fits your needs.'
      )
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="62"
          height="16"
          viewBox="0 0 62 16"
          fill="none">
          <path
            d="M61.3736 8.70711C61.7641 8.31658 61.7641 7.68342 61.3736 7.29289L55.0097 0.928932C54.6191 0.538408 53.986 0.538408 53.5954 0.928932C53.2049 1.31946 53.2049 1.95262 53.5954 2.34315L59.2523 8L53.5954 13.6569C53.2049 14.0474 53.2049 14.6805 53.5954 15.0711C53.986 15.4616 54.6191 15.4616 55.0097 15.0711L61.3736 8.70711ZM0.666504 9H60.6665V7H0.666504V9Z"
            fill="#65BA74"
          />
        </svg>
      ),
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="52"
          height="52"
          viewBox="0 0 52 52"
          fill="none">
          <path
            opacity="0.2"
            d="M43.875 9.75V17.875H8.125V9.75C8.125 9.31902 8.29621 8.9057 8.60095 8.60095C8.9057 8.29621 9.31902 8.125 9.75 8.125H42.25C42.681 8.125 43.0943 8.29621 43.399 8.60095C43.7038 8.9057 43.875 9.31902 43.875 9.75Z"
            fill="#AA99EC"
          />
          <path
            d="M42.25 6.5H37.375V4.875C37.375 4.44402 37.2038 4.0307 36.899 3.72595C36.5943 3.4212 36.181 3.25 35.75 3.25C35.319 3.25 34.9057 3.4212 34.601 3.72595C34.2962 4.0307 34.125 4.44402 34.125 4.875V6.5H17.875V4.875C17.875 4.44402 17.7038 4.0307 17.399 3.72595C17.0943 3.4212 16.681 3.25 16.25 3.25C15.819 3.25 15.4057 3.4212 15.101 3.72595C14.7962 4.0307 14.625 4.44402 14.625 4.875V6.5H9.75C8.88805 6.5 8.0614 6.84241 7.4519 7.4519C6.84241 8.0614 6.5 8.88805 6.5 9.75V42.25C6.5 43.112 6.84241 43.9386 7.4519 44.5481C8.0614 45.1576 8.88805 45.5 9.75 45.5H42.25C43.112 45.5 43.9386 45.1576 44.5481 44.5481C45.1576 43.9386 45.5 43.112 45.5 42.25V9.75C45.5 8.88805 45.1576 8.0614 44.5481 7.4519C43.9386 6.84241 43.112 6.5 42.25 6.5ZM14.625 9.75V11.375C14.625 11.806 14.7962 12.2193 15.101 12.524C15.4057 12.8288 15.819 13 16.25 13C16.681 13 17.0943 12.8288 17.399 12.524C17.7038 12.2193 17.875 11.806 17.875 11.375V9.75H34.125V11.375C34.125 11.806 34.2962 12.2193 34.601 12.524C34.9057 12.8288 35.319 13 35.75 13C36.181 13 36.5943 12.8288 36.899 12.524C37.2038 12.2193 37.375 11.806 37.375 11.375V9.75H42.25V16.25H9.75V9.75H14.625ZM42.25 42.25H9.75V19.5H42.25V42.25ZM34.4622 24.8503C34.6133 25.0012 34.7331 25.1805 34.8149 25.3777C34.8967 25.575 34.9388 25.7864 34.9388 26C34.9388 26.2136 34.8967 26.425 34.8149 26.6223C34.7331 26.8195 34.6133 26.9988 34.4622 27.1497L24.7122 36.8997C24.5613 37.0508 24.382 37.1706 24.1848 37.2524C23.9875 37.3342 23.7761 37.3763 23.5625 37.3763C23.3489 37.3763 23.1375 37.3342 22.9402 37.2524C22.743 37.1706 22.5637 37.0508 22.4128 36.8997L17.5378 32.0247C17.2329 31.7198 17.0616 31.3062 17.0616 30.875C17.0616 30.4438 17.2329 30.0302 17.5378 29.7253C17.8427 29.4204 18.2563 29.2491 18.6875 29.2491C19.1187 29.2491 19.5323 29.4204 19.8372 29.7253L23.5625 33.4527L32.1628 24.8503C32.3137 24.6992 32.493 24.5794 32.6902 24.4976C32.8875 24.4158 33.0989 24.3737 33.3125 24.3737C33.5261 24.3737 33.7375 24.4158 33.9348 24.4976C34.132 24.5794 34.3113 24.6992 34.4622 24.8503Z"
            fill="#AA99EC"
          />
        </svg>
      ),
      number: '5',
      title: t('Give Feedback in Real Time'),
      color: '#E0E7FD',
      description: t(
        'Say what works—or doesn’t. The AI refines your results instantly, learning from your input.'
      )
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="62"
          height="16"
          viewBox="0 0 62 16"
          fill="none">
          <path
            d="M61.3736 8.70711C61.7641 8.31658 61.7641 7.68342 61.3736 7.29289L55.0097 0.928932C54.6191 0.538408 53.986 0.538408 53.5954 0.928932C53.2049 1.31946 53.2049 1.95262 53.5954 2.34315L59.2523 8L53.5954 13.6569C53.2049 14.0474 53.2049 14.6805 53.5954 15.0711C53.986 15.4616 54.6191 15.4616 55.0097 15.0711L61.3736 8.70711ZM0.666504 9H60.6665V7H0.666504V9Z"
            fill="#AA99EC"
          />
        </svg>
      ),
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="52"
          viewBox="0 0 53 52"
          fill="none">
          <path
            opacity="0.2"
            d="M47.4583 26C47.4583 28.5411 43.8386 30.4586 42.8514 32.8433C41.9008 35.1427 43.1398 39.0691 41.2711 40.9378C39.4023 42.8066 35.4759 41.5675 33.1765 42.5181C30.802 43.5053 28.8723 47.125 26.3333 47.125C23.7942 47.125 21.8645 43.5053 19.49 42.5181C17.1906 41.5675 13.2642 42.8066 11.3954 40.9378C9.52669 39.0691 10.7658 35.1427 9.81513 32.8433C8.82794 30.4688 5.20825 28.5391 5.20825 26C5.20825 23.4609 8.82794 21.5312 9.81513 19.1567C10.7658 16.8594 9.52669 12.9309 11.3954 11.0622C13.2642 9.19344 17.1926 10.4325 19.49 9.48187C21.8747 8.49469 23.7942 4.875 26.3333 4.875C28.8723 4.875 30.802 8.49469 33.1765 9.48187C35.4759 10.4325 39.4023 9.19344 41.2711 11.0622C43.1398 12.9309 41.9008 16.8573 42.8514 19.1567C43.8386 21.5414 47.4583 23.4609 47.4583 26Z"
            fill="#8DA4EF"
          />
          <path
            d="M46.2111 20.8853C45.4453 20.085 44.6531 19.2603 44.3545 18.5352C44.0783 17.8709 44.062 16.77 44.0457 15.7036C44.0153 13.7211 43.9828 11.4745 42.4207 9.9125C40.8587 8.35047 38.6122 8.31797 36.6297 8.2875C35.5633 8.27125 34.4623 8.255 33.7981 7.97875C33.075 7.68016 32.2483 6.88797 31.4479 6.12219C30.0464 4.77547 28.4539 3.25 26.3333 3.25C24.2126 3.25 22.6222 4.77547 21.2186 6.12219C20.4183 6.88797 19.5936 7.68016 18.8684 7.97875C18.2083 8.255 17.1033 8.27125 16.0368 8.2875C14.0543 8.31797 11.8078 8.35047 10.2458 9.9125C8.68372 11.4745 8.66138 13.7211 8.62075 15.7036C8.6045 16.77 8.58825 17.8709 8.312 18.5352C8.01341 19.2583 7.22122 20.085 6.45544 20.8853C5.10872 22.2869 3.58325 23.8794 3.58325 26C3.58325 28.1206 5.10872 29.7111 6.45544 31.1147C7.22122 31.915 8.01341 32.7397 8.312 33.4648C8.58825 34.1291 8.6045 35.23 8.62075 36.2964C8.65122 38.2789 8.68372 40.5255 10.2458 42.0875C11.8078 43.6495 14.0543 43.682 16.0368 43.7125C17.1033 43.7287 18.2042 43.745 18.8684 44.0213C19.5915 44.3198 20.4183 45.112 21.2186 45.8778C22.6201 47.2245 24.2126 48.75 26.3333 48.75C28.4539 48.75 30.0443 47.2245 31.4479 45.8778C32.2483 45.112 33.0729 44.3198 33.7981 44.0213C34.4623 43.745 35.5633 43.7287 36.6297 43.7125C38.6122 43.682 40.8587 43.6495 42.4207 42.0875C43.9828 40.5255 44.0153 38.2789 44.0457 36.2964C44.062 35.23 44.0783 34.1291 44.3545 33.4648C44.6531 32.7417 45.4453 31.915 46.2111 31.1147C47.5578 29.7131 49.0833 28.1206 49.0833 26C49.0833 23.8794 47.5578 22.2889 46.2111 20.8853ZM43.865 28.8661C42.892 29.8817 41.8845 30.9319 41.3503 32.2217C40.8384 33.4608 40.8161 34.8766 40.7957 36.2477C40.7754 37.6695 40.7531 39.1584 40.1214 39.7881C39.4897 40.4178 38.0109 40.4422 36.5809 40.4625C35.2098 40.4828 33.794 40.5052 32.555 41.017C31.2651 41.5512 30.215 42.5588 29.1993 43.5317C28.1837 44.5047 27.1458 45.5 26.3333 45.5C25.5208 45.5 24.4747 44.5006 23.4672 43.5317C22.4597 42.5628 21.4014 41.5512 20.1115 41.017C18.8725 40.5052 17.4567 40.4828 16.0856 40.4625C14.6637 40.4422 13.1748 40.4198 12.5451 39.7881C11.9154 39.1564 11.8911 37.6777 11.8708 36.2477C11.8504 34.8766 11.8281 33.4608 11.3162 32.2217C10.782 30.9319 9.7745 29.8817 8.80153 28.8661C7.82856 27.8505 6.83325 26.8125 6.83325 26C6.83325 25.1875 7.83263 24.1414 8.80153 23.1339C9.77044 22.1264 10.782 21.0681 11.3162 19.7783C11.8281 18.5392 11.8504 17.1234 11.8708 15.7523C11.8911 14.3305 11.9134 12.8416 12.5451 12.2119C13.1768 11.5822 14.6556 11.5578 16.0856 11.5375C17.4567 11.5172 18.8725 11.4948 20.1115 10.983C21.4014 10.4488 22.4515 9.44125 23.4672 8.46828C24.4828 7.49531 25.5208 6.5 26.3333 6.5C27.1458 6.5 28.1918 7.49937 29.1993 8.46828C30.2068 9.43719 31.2651 10.4488 32.555 10.983C33.794 11.4948 35.2098 11.5172 36.5809 11.5375C38.0028 11.5578 39.4917 11.5802 40.1214 12.2119C40.7511 12.8436 40.7754 14.3223 40.7957 15.7523C40.8161 17.1234 40.8384 18.5392 41.3503 19.7783C41.8845 21.0681 42.892 22.1183 43.865 23.1339C44.8379 24.1495 45.8333 25.1875 45.8333 26C45.8333 26.8125 44.8339 27.8586 43.865 28.8661ZM35.6079 19.9753C35.759 20.1262 35.8789 20.3055 35.9607 20.5027C36.0424 20.7 36.0845 20.9114 36.0845 21.125C36.0845 21.3386 36.0424 21.55 35.9607 21.7473C35.8789 21.9445 35.759 22.1238 35.6079 22.2747L24.2329 33.6497C24.082 33.8008 23.9028 33.9206 23.7055 34.0024C23.5083 34.0842 23.2968 34.1263 23.0833 34.1263C22.8697 34.1263 22.6582 34.0842 22.461 34.0024C22.2637 33.9206 22.0845 33.8008 21.9336 33.6497L17.0586 28.7747C16.7536 28.4698 16.5823 28.0562 16.5823 27.625C16.5823 27.1938 16.7536 26.7802 17.0586 26.4753C17.3635 26.1704 17.777 25.9991 18.2083 25.9991C18.6395 25.9991 19.053 26.1704 19.3579 26.4753L23.0833 30.2027L33.3086 19.9753C33.4595 19.8242 33.6387 19.7044 33.836 19.6226C34.0332 19.5408 34.2447 19.4987 34.4583 19.4987C34.6718 19.4987 34.8833 19.5408 35.0805 19.6226C35.2778 19.7044 35.457 19.8242 35.6079 19.9753Z"
            fill="#8DA4EF"
          />
        </svg>
      ),
      number: '6',
      title: t('Apply with Confidence'),
      color: '#7B83EB',
      description: t(
        'With full insight into true living costs, commute times, and lifestyle fit, you’re ready to act fast on the right property.'
      )
    }
  ];

  const ownerSteps = [
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="52"
          viewBox="0 0 53 52"
          fill="none">
          <path
            opacity="0.2"
            d="M44.0417 23.7027V43.8751H31.0417V30.8751H21.2917V43.8751H8.29175V23.7027L25.0171 6.97537C25.168 6.82428 25.3472 6.70443 25.5445 6.62265C25.7417 6.54087 25.9532 6.49878 26.1667 6.49878C26.3803 6.49878 26.5918 6.54087 26.789 6.62265C26.9863 6.70443 27.1655 6.82428 27.3164 6.97537L44.0417 23.7027Z"
            fill="#8DA4EF"
          />
          <path
            d="M48.9167 42.25H45.6667V27.625L46.1421 28.1004C46.4475 28.4053 46.8616 28.5764 47.2932 28.576C47.7248 28.5756 48.1385 28.4038 48.4435 28.0983C48.7484 27.7929 48.9195 27.3788 48.9191 26.9472C48.9187 26.5156 48.7469 26.1018 48.4414 25.7969L28.4641 5.82566C27.8547 5.21663 27.0283 4.87451 26.1667 4.87451C25.3052 4.87451 24.4788 5.21663 23.8694 5.82566L3.89206 25.7969C3.58741 26.1018 3.41637 26.5153 3.41656 26.9463C3.41675 27.3773 3.58816 27.7906 3.89308 28.0953C4.19799 28.3999 4.61144 28.571 5.04247 28.5708C5.47349 28.5706 5.88679 28.3992 6.19144 28.0943L6.66675 27.625V42.25H3.41675C2.98577 42.25 2.57245 42.4212 2.2677 42.726C1.96295 43.0307 1.79175 43.4441 1.79175 43.875C1.79175 44.306 1.96295 44.7193 2.2677 45.0241C2.57245 45.3288 2.98577 45.5 3.41675 45.5H48.9167C49.3477 45.5 49.7611 45.3288 50.0658 45.0241C50.3705 44.7193 50.5417 44.306 50.5417 43.875C50.5417 43.4441 50.3705 43.0307 50.0658 42.726C49.7611 42.4212 49.3477 42.25 48.9167 42.25ZM9.91675 24.375L26.1667 8.12504L42.4167 24.375V42.25H32.6667V30.875C32.6667 30.4441 32.4955 30.0307 32.1908 29.726C31.8861 29.4212 31.4727 29.25 31.0417 29.25H21.2917C20.8608 29.25 20.4474 29.4212 20.1427 29.726C19.838 30.0307 19.6667 30.4441 19.6667 30.875V42.25H9.91675V24.375ZM29.4167 42.25H22.9167V32.5H29.4167V42.25Z"
            fill="#8DA4EF"
          />
        </svg>
      ),
      number: '1',
      title: t('List Your Property for Free'),
      color: '#E0E7FD',
      description: t(
        "Start by promoting your property on our platform at no cost. Our AI-driven system helps you reach a wide audience of potential tenants, maximizing your property's exposure with zero upfront expense. We help you generate videos and improve the quality of your pictures."
      )
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="62"
          height="16"
          viewBox="0 0 62 16"
          fill="none">
          <path
            d="M61.5404 8.70711C61.9309 8.31658 61.9309 7.68342 61.5404 7.29289L55.1764 0.928932C54.7859 0.538408 54.1527 0.538408 53.7622 0.928932C53.3717 1.31946 53.3717 1.95262 53.7622 2.34315L59.419 8L53.7622 13.6569C53.3717 14.0474 53.3717 14.6805 53.7622 15.0711C54.1527 15.4616 54.7859 15.4616 55.1764 15.0711L61.5404 8.70711ZM0.833252 9H60.8333V7H0.833252V9Z"
            fill="#8DA4EF"
          />
        </svg>
      ),
      number: '2'
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="52"
          viewBox="0 0 53 52"
          fill="none">
          <path
            opacity="0.2"
            d="M40.0728 30.7592L28.8826 34.8826L24.7592 46.0728C24.6453 46.3813 24.4396 46.6476 24.1697 46.8356C23.8999 47.0236 23.5789 47.1245 23.25 47.1245C22.9211 47.1245 22.6001 47.0236 22.3302 46.8356C22.0604 46.6476 21.8546 46.3813 21.7408 46.0728L17.6173 34.8826L6.42716 30.7592C6.11861 30.6453 5.85238 30.4396 5.66434 30.1697C5.4763 29.8999 5.37549 29.5789 5.37549 29.25C5.37549 28.9211 5.4763 28.6001 5.66434 28.3302C5.85238 28.0604 6.11861 27.8546 6.42716 27.7408L17.6173 23.6173L21.7408 12.4272C21.8546 12.1186 22.0604 11.8524 22.3302 11.6643C22.6001 11.4763 22.9211 11.3755 23.25 11.3755C23.5789 11.3755 23.8999 11.4763 24.1697 11.6643C24.4396 11.8524 24.6453 12.1186 24.7592 12.4272L28.8826 23.6173L40.0728 27.7408C40.3813 27.8546 40.6476 28.0604 40.8356 28.3302C41.0236 28.6001 41.1245 28.9211 41.1245 29.25C41.1245 29.5789 41.0236 29.8999 40.8356 30.1697C40.6476 30.4396 40.3813 30.6453 40.0728 30.7592Z"
            fill="#65BA74"
          />
          <path
            d="M40.6334 26.2153L30.1562 22.3437L26.2968 11.8584C26.0683 11.2375 25.6548 10.7017 25.1121 10.3232C24.5695 9.94468 23.9238 9.74174 23.2621 9.74174C22.6005 9.74174 21.9548 9.94468 21.4122 10.3232C20.8695 10.7017 20.456 11.2375 20.2275 11.8584L16.3437 22.3437L5.85839 26.2031C5.2375 26.4317 4.70165 26.8452 4.32315 27.3878C3.94464 27.9305 3.7417 28.5762 3.7417 29.2378C3.7417 29.8994 3.94464 30.5451 4.32315 31.0878C4.70165 31.6305 5.2375 32.044 5.85839 32.2725L16.3437 36.1562L20.2031 46.6416C20.4316 47.2625 20.8451 47.7983 21.3878 48.1768C21.9304 48.5553 22.5762 48.7583 23.2378 48.7583C23.8994 48.7583 24.5451 48.5553 25.0878 48.1768C25.6304 47.7983 26.0439 47.2625 26.2725 46.6416L30.1562 36.1562L40.6415 32.2969C41.2624 32.0683 41.7983 31.6548 42.1768 31.1122C42.5553 30.5695 42.7582 29.9238 42.7582 29.2622C42.7582 28.6006 42.5553 27.9549 42.1768 27.4122C41.7983 26.8695 41.2624 26.456 40.6415 26.2275L40.6334 26.2153ZM28.3281 33.3572C28.1075 33.4385 27.9072 33.5667 27.741 33.7329C27.5747 33.8991 27.4466 34.0994 27.3653 34.32L23.25 45.4695L19.1428 34.3281C19.0616 34.1052 18.9326 33.9028 18.7649 33.7351C18.5972 33.5673 18.3947 33.4383 18.1718 33.3572L7.03043 29.25L18.1718 25.1428C18.3947 25.0616 18.5972 24.9327 18.7649 24.7649C18.9326 24.5972 19.0616 24.3948 19.1428 24.1719L23.25 13.0305L27.3571 24.1719C27.4384 24.3924 27.5666 24.5928 27.7328 24.759C27.8991 24.9252 28.0994 25.0534 28.32 25.1347L39.4695 29.25L28.3281 33.3572ZM29.75 8.125C29.75 7.69402 29.9212 7.2807 30.2259 6.97595C30.5307 6.67121 30.944 6.5 31.375 6.5H34.625V3.25C34.625 2.81902 34.7962 2.4057 35.1009 2.10095C35.4057 1.7962 35.819 1.625 36.25 1.625C36.6809 1.625 37.0943 1.7962 37.399 2.10095C37.7038 2.4057 37.875 2.81902 37.875 3.25V6.5H41.125C41.5559 6.5 41.9693 6.67121 42.274 6.97595C42.5788 7.2807 42.75 7.69402 42.75 8.125C42.75 8.55598 42.5788 8.9693 42.274 9.27405C41.9693 9.57879 41.5559 9.75 41.125 9.75H37.875V13C37.875 13.431 37.7038 13.8443 37.399 14.149C37.0943 14.4538 36.6809 14.625 36.25 14.625C35.819 14.625 35.4057 14.4538 35.1009 14.149C34.7962 13.8443 34.625 13.431 34.625 13V9.75H31.375C30.944 9.75 30.5307 9.57879 30.2259 9.27405C29.9212 8.9693 29.75 8.55598 29.75 8.125ZM50.875 17.875C50.875 18.306 50.7038 18.7193 50.399 19.024C50.0943 19.3288 49.6809 19.5 49.25 19.5H47.625V21.125C47.625 21.556 47.4538 21.9693 47.149 22.274C46.8443 22.5788 46.4309 22.75 46 22.75C45.569 22.75 45.1557 22.5788 44.8509 22.274C44.5462 21.9693 44.375 21.556 44.375 21.125V19.5H42.75C42.319 19.5 41.9057 19.3288 41.6009 19.024C41.2962 18.7193 41.125 18.306 41.125 17.875C41.125 17.444 41.2962 17.0307 41.6009 16.726C41.9057 16.4212 42.319 16.25 42.75 16.25H44.375V14.625C44.375 14.194 44.5462 13.7807 44.8509 13.476C45.1557 13.1712 45.569 13 46 13C46.4309 13 46.8443 13.1712 47.149 13.476C47.4538 13.7807 47.625 14.194 47.625 14.625V16.25H49.25C49.6809 16.25 50.0943 16.4212 50.399 16.726C50.7038 17.0307 50.875 17.444 50.875 17.875Z"
            fill="#65BA74"
          />
        </svg>
      ),
      number: '3',
      title: t('Personalized Property Consultation'),
      color: '#E0E7FD',
      description: t(
        'Engage with our AI real estate agent to define your ideal tenant profile and key criteria. Our AI understands your preferences, such as rent affordability, tenant background, and desired lease terms, to find the perfect match.'
      )
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="62"
          height="16"
          viewBox="0 0 62 16"
          fill="none">
          <path
            d="M60.8736 8.70711C61.2641 8.31658 61.2641 7.68342 60.8736 7.29289L54.5097 0.928932C54.1191 0.538408 53.486 0.538408 53.0954 0.928932C52.7049 1.31946 52.7049 1.95262 53.0954 2.34315L58.7523 8L53.0954 13.6569C52.7049 14.0474 52.7049 14.6805 53.0954 15.0711C53.486 15.4616 54.1191 15.4616 54.5097 15.0711L60.8736 8.70711ZM0.166504 9H60.1665V7H0.166504V9Z"
            fill="#65BA74"
          />
        </svg>
      ),
      number: '4'
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="52"
          viewBox="0 0 53 52"
          fill="none">
          <path
            opacity="0.2"
            d="M45.9066 12.4678L31.7082 27.625V39.5383C31.7084 39.8059 31.6424 40.0694 31.5163 40.3054C31.3901 40.5414 31.2077 40.7426 30.9851 40.8911L24.4851 45.2238C24.2406 45.3869 23.9564 45.4806 23.6628 45.495C23.3693 45.5094 23.0773 45.444 22.818 45.3056C22.5587 45.1672 22.3418 44.961 22.1904 44.7091C22.039 44.4572 21.9587 44.1689 21.9582 43.875V27.625L7.75975 12.4678C7.5483 12.2351 7.4089 11.9461 7.35845 11.6357C7.30801 11.3254 7.34868 11.007 7.47554 10.7194C7.6024 10.4317 7.81 10.1869 8.07317 10.0149C8.33634 9.84283 8.64377 9.75082 8.95819 9.75H44.7082C45.0226 9.75082 45.33 9.84283 45.5932 10.0149C45.8564 10.1869 46.064 10.4317 46.1908 10.7194C46.3177 11.007 46.3584 11.3254 46.3079 11.6357C46.2575 11.9461 46.1181 12.2351 45.9066 12.4678Z"
            fill="#AA99EC"
          />
          <path
            d="M47.6736 10.0608C47.4235 9.48297 47.009 8.99137 46.4817 8.64719C45.9544 8.30302 45.3376 8.12144 44.708 8.12505H8.95795C8.32894 8.12629 7.7138 8.31004 7.18716 8.654C6.66052 8.99797 6.24501 9.48737 5.99104 10.0628C5.73707 10.6383 5.65556 11.2751 5.75638 11.896C5.8572 12.5169 6.13603 13.0951 6.55905 13.5607L6.5753 13.579L20.333 28.269V43.8751C20.3328 44.4633 20.4923 45.0405 20.7944 45.5452C21.0966 46.0498 21.53 46.4631 22.0485 46.7408C22.567 47.0185 23.1512 47.1503 23.7387 47.1221C24.3263 47.0939 24.8951 46.9068 25.3847 46.5807L31.8847 42.246C32.3303 41.9492 32.6956 41.5469 32.9483 41.0749C33.2009 40.6029 33.3331 40.0758 33.333 39.5404V28.269L47.0926 13.579L47.1089 13.5607C47.5364 13.0973 47.8179 12.5182 47.9183 11.8958C48.0187 11.2734 47.9336 10.6352 47.6736 10.0608ZM30.5258 26.5241C30.2447 26.8222 30.0865 27.2154 30.083 27.6251V39.5404L23.583 43.8751V27.6251C23.5831 27.2124 23.4262 26.8152 23.1442 26.514L8.95795 11.3751H44.708L30.5258 26.5241Z"
            fill="#AA99EC"
          />
        </svg>
      ),
      number: '5',
      title: t('Smart Application Filtering'),
      color: '#E0E7FD',
      description: t(
        'Let our AI handle the heavy lifting. We filter all incoming applications according to your criteria, rating the only the candidates. For each selected applicant, our AI provides an in-depth analysis, say goodbye to sorting through countless applications and focus on the best options.'
      )
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="52"
          viewBox="0 0 53 52"
          fill="none">
          <path
            opacity="0.2"
            d="M44.0417 11.375V24.375H32.6667V11.375H44.0417ZM8.29175 42.25C8.29175 42.681 8.46295 43.0943 8.7677 43.399C9.07245 43.7038 9.48577 43.875 9.91675 43.875H18.0417C18.4727 43.875 18.886 43.7038 19.1908 43.399C19.4955 43.0943 19.6667 42.681 19.6667 42.25V24.375H8.29175V42.25Z"
            fill="#65BA74"
          />
          <path
            d="M44.0417 9.75H8.29175C7.86077 9.75 7.44745 9.92121 7.1427 10.226C6.83795 10.5307 6.66675 10.944 6.66675 11.375V42.25C6.66675 43.112 7.00916 43.9386 7.61865 44.5481C8.22814 45.1576 9.05479 45.5 9.91675 45.5H18.0417C18.9037 45.5 19.7304 45.1576 20.3398 44.5481C20.9493 43.9386 21.2917 43.112 21.2917 42.25V32.5H31.0417V35.75C31.0417 36.612 31.3842 37.4386 31.9937 38.0481C32.6031 38.6576 33.4298 39 34.2917 39H42.4167C43.2787 39 44.1054 38.6576 44.7148 38.0481C45.3243 37.4386 45.6667 36.612 45.6667 35.75V11.375C45.6667 10.944 45.4955 10.5307 45.1908 10.226C44.8861 9.92121 44.4727 9.75 44.0417 9.75ZM42.4167 22.75H34.2917V13H42.4167V22.75ZM18.0417 13V22.75H9.91675V13H18.0417ZM18.0417 42.25H9.91675V26H18.0417V42.25ZM21.2917 29.25V13H31.0417V29.25H21.2917ZM34.2917 35.75V26H42.4167V35.75H34.2917Z"
            fill="#65BA74"
          />
        </svg>
      ),
      number: '6',
      title: t('Efficient Application Management'),
      color: '#E0E7FD',
      description: t(
        'We streamline the process by automatically removing your property ad once the desired number of qualified matches is identified. This saves you time and prevents unnecessary inquiries, ensuring you only engage with the best-fit applicants.'
      )
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="62"
          height="16"
          viewBox="0 0 62 16"
          fill="none">
          <path
            d="M60.8736 8.70711C61.2641 8.31658 61.2641 7.68342 60.8736 7.29289L54.5097 0.928932C54.1191 0.538408 53.486 0.538408 53.0954 0.928932C52.7049 1.31946 52.7049 1.95262 53.0954 2.34315L58.7523 8L53.0954 13.6569C52.7049 14.0474 52.7049 14.6805 53.0954 15.0711C53.486 15.4616 54.1191 15.4616 54.5097 15.0711L60.8736 8.70711ZM0.166504 9H60.1665V7H0.166504V9Z"
            fill="#65BA74"
          />
        </svg>
      ),
      number: '7'
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="52"
          viewBox="0 0 53 52"
          fill="none">
          <path
            opacity="0.2"
            d="M42.75 17.875H31.375V6.5L42.75 17.875ZM24.875 32.5C24.875 32.069 24.7038 31.6557 24.399 31.351C24.0943 31.0462 23.681 30.875 23.25 30.875H10.25C9.81902 30.875 9.4057 31.0462 9.10095 31.351C8.79621 31.6557 8.625 32.069 8.625 32.5V42.25C8.625 42.681 8.79621 43.0943 9.10095 43.399C9.4057 43.7038 9.81902 43.875 10.25 43.875H23.25C23.681 43.875 24.0943 43.7038 24.399 43.399C24.7038 43.0943 24.875 42.681 24.875 42.25V39.8125L31.375 43.875V30.875L24.875 34.9375V32.5Z"
            fill="#AA99EC"
          />
          <path
            d="M43.8997 16.7253L32.5247 5.35031C32.3737 5.19946 32.1944 5.07983 31.9971 4.99828C31.7999 4.91672 31.5885 4.87483 31.375 4.875H11.875C11.013 4.875 10.1864 5.21741 9.5769 5.8269C8.96741 6.4364 8.625 7.26305 8.625 8.125V22.75C8.625 23.181 8.79621 23.5943 9.10095 23.899C9.4057 24.2038 9.81902 24.375 10.25 24.375C10.681 24.375 11.0943 24.2038 11.399 23.899C11.7038 23.5943 11.875 23.181 11.875 22.75V8.125H29.75V17.875C29.75 18.306 29.9212 18.7193 30.226 19.024C30.5307 19.3288 30.944 19.5 31.375 19.5H41.125V43.875H39.5C39.069 43.875 38.6557 44.0462 38.351 44.351C38.0462 44.6557 37.875 45.069 37.875 45.5C37.875 45.931 38.0462 46.3443 38.351 46.649C38.6557 46.9538 39.069 47.125 39.5 47.125H41.125C41.987 47.125 42.8136 46.7826 43.4231 46.1731C44.0326 45.5636 44.375 44.737 44.375 43.875V17.875C44.3752 17.6615 44.3333 17.4501 44.2517 17.2529C44.1702 17.0556 44.0505 16.8763 43.8997 16.7253ZM33 10.4223L38.8277 16.25H33V10.4223ZM32.1631 29.4531C31.9093 29.3126 31.6224 29.2427 31.3323 29.2506C31.0423 29.2584 30.7596 29.3438 30.5137 29.4978L26.4614 32.0287C26.3484 31.2574 25.9618 30.5524 25.3723 30.0423C24.7828 29.5322 24.0296 29.251 23.25 29.25H10.25C9.38805 29.25 8.5614 29.5924 7.9519 30.2019C7.34241 30.8114 7 31.638 7 32.5V42.25C7 43.112 7.34241 43.9386 7.9519 44.5481C8.5614 45.1576 9.38805 45.5 10.25 45.5H23.25C24.0296 45.499 24.7828 45.2178 25.3723 44.7077C25.9618 44.1976 26.3484 43.4926 26.4614 42.7213L30.5137 45.2522C30.7597 45.4059 31.0422 45.491 31.3321 45.4986C31.622 45.5063 31.9087 45.4362 32.1624 45.2957C32.4161 45.1552 32.6275 44.9493 32.7748 44.6995C32.9221 44.4497 32.9999 44.165 33 43.875V30.875C33.0001 30.5849 32.9226 30.3 32.7754 30.05C32.6283 29.7999 32.4168 29.5938 32.1631 29.4531ZM23.25 42.25H10.25V32.5H23.25V42.25ZM29.75 40.9439L26.5 38.9127V35.8373L29.75 33.8061V40.9439Z"
            fill="#AA99EC"
          />
        </svg>
      ),
      number: '8',
      title: t('Smart View Experience'),
      color: '#E0E7FD',
      description: t(
        'After you approve a candidate, record a video of your property’s highlights and upload it to our platform. We’ll provide a secure key box to place outside your flat. Prospective tenants can schedule viewings through our app, receive a one-time access code, and tour the flat independently. You’ll be notified of their entry, duration, and exit while remaining fully insured against any incidents.'
      )
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="62"
          height="16"
          viewBox="0 0 62 16"
          fill="none">
          <path
            d="M61.5404 8.70711C61.9309 8.31658 61.9309 7.68342 61.5404 7.29289L55.1764 0.928932C54.7859 0.538408 54.1527 0.538408 53.7622 0.928932C53.3717 1.31946 53.3717 1.95262 53.7622 2.34315L59.419 8L53.7622 13.6569C53.3717 14.0474 53.3717 14.6805 53.7622 15.0711C54.1527 15.4616 54.7859 15.4616 55.1764 15.0711L61.5404 8.70711ZM0.833252 9H60.8333V7H0.833252V9Z"
            fill="#8DA4EF"
          />
        </svg>
      ),
      number: '9'
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="52"
          viewBox="0 0 53 52"
          fill="none">
          <path
            opacity="0.2"
            d="M21.958 21.125V42.25H8.95801C8.52703 42.25 8.11371 42.0788 7.80896 41.774C7.50421 41.4693 7.33301 41.056 7.33301 40.625V21.125H21.958Z"
            fill="#8DA4EF"
          />
          <path
            d="M44.708 8.125H8.95801C8.09605 8.125 7.2694 8.46741 6.65991 9.0769C6.05042 9.6864 5.70801 10.513 5.70801 11.375V40.625C5.70801 41.487 6.05042 42.3136 6.65991 42.9231C7.2694 43.5326 8.09605 43.875 8.95801 43.875H44.708C45.57 43.875 46.3966 43.5326 47.0061 42.9231C47.6156 42.3136 47.958 41.487 47.958 40.625V11.375C47.958 10.513 47.6156 9.6864 47.0061 9.0769C46.3966 8.46741 45.57 8.125 44.708 8.125ZM44.708 11.375V19.5H8.95801V11.375H44.708ZM8.95801 22.75H20.333V40.625H8.95801V22.75ZM44.708 40.625H23.583V22.75H44.708V40.625Z"
            fill="#8DA4EF"
          />
        </svg>
      ),
      number: '10',
      title: t('Manage Everything in One Place'),
      color: '#E0E7FD',
      description: t(
        'Handle all your tenant communications, document management, and contract signing directly through our integrated platform. From sending messages to drafting lease agreements, everything is done in one place, making the entire process seamless and stress-free.'
      )
    }
  ];

  const steps = userType === 'tenant' ? tenantSteps : ownerSteps;

  return (
    <Box id="how-it-works" sx={{ flexGrow: 1, pt: 10, pb: 6, textAlign: 'center' }}>
      <Container maxWidth="xl">
        <Typography variant="h5" gutterBottom sx={{ fontWeight: '700', fontSize: '35px' }}>
          {title}
        </Typography>
        {!isTenants && !isOwners && (
          <Typography variant="subtitle1" gutterBottom sx={{ fontSize: '18px', color: '#6B7280' }}>
            {t('AI Real Estate Agent: Your Smartest Move Yet!')}
          </Typography>
        )}
        {/* {!isTenants && !isOwners && (
          <Box sx={{ display: "flex", justifyContent: "center", my: 5 }}>
            <ToggleButtonGroup
              color="primary"
              value={userType}
              exclusive
              onChange={handleChange}
              aria-label="User Type"
              sx={{
                backgroundColor: "#F3F4F6",
                "& .MuiToggleButton-root": {
                  border: "none",
                  borderRadius: "20px",
                  px: 3,
                  py: 1,
                  height: "40px",
                  cursor: "pointer",
                  fontWeight: 400,
                  "&:hover": {
                    borderRadius: 0,
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#FFF",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    borderRadius: "6px",
                    border: "1px solid rgba(0, 0, 45, 0.09)",
                    color: "#000509E3",
                    fontWeight: 400,
                  },
                },
              }}
            >
              <ToggleButton
                value="tenant"
                aria-label="tenant"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "#000509E3",
                  "&:hover": {
                    borderRadius: 0,
                  },
                }}
              >
                {t("I'm a Tenant")}
              </ToggleButton>
              <ToggleButton
                value="owner"
                aria-label="owner"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "#000509E3",
                  "&:hover": {
                    borderRadius: 0,
                  },
                }}
              >
                {t("I'm an Owner")}
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        )} */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '100%', // For extra-small screens, use a single column layout
              sm: 'auto 100px auto 100px auto' // For small screens and up, use the defined grid layout
            },
            gap: {
              xs: 2,
              sm: 2,
              md: 4
            },
            py: 5, // Padding y-axis
            justifyContent: 'center',
            alignItems: 'flex-start'
          }}>
          {steps.map((step, index) =>
            step.title ? (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={2}
                key={index}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  margin: 'auto',
                  padding: '8px',
                  maxWidth: '300px',
                  width: '100%'
                }}>
                <Box sx={{ textAlign: 'center' }}>
                  <Box sx={{ position: 'relative', mb: 3 }}>
                    <Box
                      sx={{
                        width: '80px', // Adjusted size to fit 5 items per row
                        height: '80px', // Adjusted size to fit 5 items per row
                        borderRadius: '50%',
                        backgroundColor: '#F5F8FF',
                        margin: '0 auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '1px solid #E0E5FF',
                        position: 'relative'
                      }}>
                      {step.icon}
                      <Box
                        sx={{
                          position: 'absolute',
                          top: -5,
                          right: -5,
                          width: '20px',
                          height: '20px',
                          borderRadius: '50%',
                          backgroundColor: `${step.color}`,
                          border: `2px solid ${step.color}`,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          color: '#fff',
                          fontSize: '10px', // Adjusted font size to fit better
                          fontWeight: 'bold'
                        }}>
                        {step.number}
                      </Box>
                    </Box>
                  </Box>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        fontSize: '16px',
                        color: '#2F2F2F'
                      }}>
                      {step.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#6B7280',
                        fontSize: '14px',
                        margin: '5px auto'
                      }}>
                      {step.description}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ) : (
              <Box sx={{ height: '100%', top: '50%', position: 'relative' }}>{step.icon}</Box>
            )
          )}
        </Box>
      </Container>
    </Box>
  );
};

HowItWorks.propTypes = {
  title: PropTypes.string.isRequired,
  isTenants: PropTypes.bool
};

export default HowItWorks;
